
// ... (Update and Delete mutations can be added similarly if needed)


// Example Component Usage:
import React, { useState } from 'react';
import { useAddAssignment, useDeleteAssignment, useFetchAssignments, useUpdateAssignment } from '../../hooks/api/assignment/assignment';
import { useFetchUsers } from '../../hooks/api/users/users';
import { useFetchOrganizations } from '../../hooks/api/organisation/organisation';
import { useFetchProjects } from '../../hooks/api/projects/projects';
import { useFetchLocations } from '../../hooks/api/location/location';
import { useFetchSurvey } from '../../hooks/api/survey/survey';
import { Autocomplete, Pagination, TextField } from '@mui/material';
import Select from 'react-select';
const AssignmentManagement = () => {
  const [filters, setFilters]= useState({
    pageNumber:1,
    pageSize:10,
    search:"",
    orgId:""

})
  
  const { data: assignments, isLoading, error } = useFetchAssignments(filters); // If you're displaying assignments
  const updateAssignment = useUpdateAssignment(); // Add update mutation
  const deleteAssignment = useDeleteAssignment(); // Add delete mutation
  const [editAssignment, setEditAssignment] = useState(null); // For edit mode

  const addAssignment = useAddAssignment();
  const [newAssignment, setNewAssignment] = useState({
    userId: '',
    date: '',
    orgId: '',
    projectId: '',
    locationId: '',
    surveyTypeId:""
  });

  
  // Fetch Options for Select Dropdowns (replace with your actual API calls)
  const { data: users } = useFetchUsers({...filters, pageSize:100000})
//   useQuery(['fetch users'], () => instance.get('/api/users').then(res => res.data));
  const { data: organizations } = useFetchOrganizations({...filters, pageSize:100000})
//   useQuery(['fetch organizations'], () => instance.get('/api/organizations').then(res => res.data));
  const { data: projects } = useFetchProjects({...filters, pageSize:100000})
//   useQuery(['fetch projects'], () => instance.get('/api/projects').then(res => res.data));
  const { data: locations } = useFetchLocations({...filters, pageSize:100000})
  const { data: survey } = useFetchSurvey({...filters, pageSize:100000})
//   useQuery(['fetch locations'], () => instance.get('/api/locations').then(res => res.data));


  const handleInputChange = (e) => {
    setNewAssignment({ ...newAssignment, [e.target.name]: e.target.value });
  };

  const handleAddAssignment = async (e) => {
    e.preventDefault();
    try {
      await addAssignment.mutateAsync(newAssignment);
      setNewAssignment({  // Clear form
        userId: '',
        date: '',
        orgId: '',
        projectId: '',
        locationId: '',
      });
      alert("Assignment added successfully!");
    } catch (error) {
       console.error("Error adding assignment:", error);
      alert("Error adding assignment. Please try again.");
    }
  };


  const handleDeleteAssignment = async (assignmentId) => {
    try {
      await deleteAssignment.mutateAsync(assignmentId);
      alert("Assignment deleted successfully!");
    } catch (error) {
       console.error("Error deleting assignment:", error);
      alert("Error deleting assignment. Please try again.");
    }
  };

  const handleEditAssignment = (assignment) => {
    setEditAssignment({ ...assignment }); // Set the assignment to be edited
  };

  const handleUpdateAssignment = async () => {
    try {
      await updateAssignment.mutateAsync(editAssignment); // Use the update mutation
      setEditAssignment(null); // Close the edit form/modal
      alert("Assignment updated successfully!");
    } catch (error) {
       console.error("Error updating assignment:", error);
      alert("Error updating assignment. Please try again.");
    }
  };



  if (isLoading) {
    return <div>Loading assignments...</div>;
  }

  if (error) {
    return <div>Error loading assignments: {error?.message}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1>Assignment Management</h1>

      {/* Add Assignment Form */}
      <form onSubmit={handleAddAssignment} className="bg-white rounded-lg shadow-md p-6 mb-4">
        {/* ... other input fields */}
{/* <p>Select User: </p>
        <Select
         name="userId" 
        value={newAssignment.userId} 
        showSearch
        labelInValue
        onChange={handleInputChange} 
        className="border rounded px-3 py-2" 
        required
        options={users?.users?.filter(x=>x.role==="shopper")?.map(prev=>({value:prev.id, label:prev.firstName}))}
        >
           <Option value="">Select User</Option>
          {users?.users?.filter(x=>x.role==="shopper")?.map((user) => (
            <Option key={user.id} value={user.id}>{user.firstName}</Option> // Adjust user data structure
          ))} 
        </Select> */}


        <Autocomplete
        
        name="userId" 
        onChange={(event, newValue) => {
          setNewAssignment(prev=>({...prev, userId:newValue?.value}));
        }}
  disablePortal
  options={users?.users?.filter(x=>x.role==="shopper")?.map(prev=>({value:prev.id, label:prev.firstName}))}
  sx={{ width: 300 }}
  renderInput={(params) => <TextField {...params} label="Select User" />}
/>

<div className="my-4">

        <input type="date" name="date" value={newAssignment.date} onChange={handleInputChange} className="border rounded px-3 py-2 mx-4" required />

        <select name="orgId" value={newAssignment.orgId} onChange={handleInputChange} className="border rounded px-3 py-2" required>
          <option value="">Select Organization</option>
          {organizations?.orgs?.map((org) => (
            <option key={org.id} value={org.id}>{org.name}</option> // Adjust org data structure
          ))}
        </select>

        <select name="projectId" value={newAssignment.projectId} onChange={handleInputChange} 
        className="border rounded px-3 py-2 mx-4 " required>
          <option value="">Select Project</option>
          {projects?.projects?.map((project) => (
            <option key={project.id} value={project.id}>{project.name}</option> // Adjust project data structure
          ))}
        </select>

        {/* <select
         name="locationId" 
         onChange={handleInputChange} 
         value={newAssignment.locationId} 
         className="border rounded px-3 py-2" required>
          <option value="">Select Location</option>
          {locations?.locations?.map((location) => (
            <option key={location.id} value={location.id}>{location.name}</option>
          ))}
        </select> */}


</div>

        <Autocomplete
  disablePortal
  
  name="locationId" 
  onChange={(event, newValue) => {
    setNewAssignment(prev=>({...prev, locationId:newValue?.value}));
  }} options={locations?.locations?.map((location) => ({value:location.id, label:location.name}))}
  // sx={{ width: 300 }}
  renderInput={(params) => <TextField {...params} label="Select Location" />}
/>


        <select name="surveyTypeId" 
        // value={newAssignment.locationId} 
        onChange={handleInputChange}
        className="border rounded px-3 py-2 mx-4" required>
          <option value="">Select Survey</option>
          {survey?.surveyTypes?.map((location) => (
            <option key={location.id} value={location.id}>{location.name}</option>
          ))}
        </select>

        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4">
          Add Assignment
        </button>
      </form>

      {/* ... (Table to display assignments if needed) */}

 {/* Assignment Table */}
 <div className="bg-white rounded-lg shadow-md p-6 mt-4"> {/* Added margin-top */}
        <h2 className="text-xl font-semibold mb-2">Assignment List</h2>
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className='text-left'>
              <th className="px-4 py-2 text-left">User</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Organization</th>
              <th className="px-4 py-2">Project</th>
              <th className="px-4 py-2">Location</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {assignments?.assignments?.map((assignment) => (
              <tr key={assignment.id}> {/* Make sure your data has a unique id */}
                <td className="px-4 py-2">{/* Display User Name */}
                {users?.users?.find(user => user.id === assignment.userId)?.firstName || "N/A"}
                </td>
                <td className="px-4 py-2">{assignment.date}</td>
                <td className="px-4 py-2">{/* Display Organization Name */}
                {organizations?.orgs?.find(org => org.id === assignment.orgId)?.name || "N/A"}
                </td>
                <td className="px-4 py-2">{/* Display Project Name */}
                {projects?.projects?.find(project => project.id === assignment.projectId)?.name || "N/A"}
                </td>
                <td className="px-4 py-2">{/* Display Location Name */}
                {locations?.locations?.find(location => location.id === assignment.locationId)?.name || "N/A"}
                </td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEditAssignment(assignment)} // Pass the assignment object
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteAssignment(assignment.id)} // Pass the assignment ID
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

          <Pagination count={assignments?.pagination?.totalPages} page={filters.pageNumber} onChange={ (event, value) => {
                      setFilters(prev=>({...prev, pageNumber:value}))
                    }} />
      </div>

      {/* Edit Assignment Form (Conditional Rendering) */}
      {editAssignment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-2">Edit Assignment</h2>
            {/* ... (Edit form inputs - similar to Add Assignment form, but pre-filled with editAssignment data) */}
            <select name="userId" value={editAssignment.userId} onChange={(e) => setEditAssignment({...editAssignment, userId: e.target.value})} className="border rounded px-3 py-2" required>
            <option value="">Select User</option>
            {users?.users?.map((user) => (
                <option key={user.id} value={user.id}>{user.name}</option> 
            ))}
            </select>
             <input type="date" name="date" value={editAssignment.date} onChange={(e) => setEditAssignment({...editAssignment, date: e.target.value})} className="border rounded px-3 py-2" required />

            <select name="orgId" value={editAssignment.orgId} onChange={(e) => setEditAssignment({...editAssignment, orgId: e.target.value})} className="border rounded px-3 py-2" required>
            <option value="">Select Organization</option>
            {organizations?.orgs?.map((org) => (
                <option key={org.id} value={org.id}>{org.name}</option> 
            ))}
            </select>

            <select name="projectId" value={editAssignment.projectId} onChange={(e) => setEditAssignment({...editAssignment, projectId: e.target.value})} className="border rounded px-3 py-2" required>
            <option value="">Select Project</option>
            {projects?.projetcs?.map((project) => (
                <option key={project.id} value={project.id}>{project.name}</option> 
            ))}
            </select>

            <select name="locationId" value={editAssignment.locationId} onChange={(e) => setEditAssignment({...editAssignment, locationId: e.target.value})} className="border rounded px-3 py-2" required>
            <option value="">Select Location</option>
            {locations?.locations?.map((location) => (
                <option key={location.id} value={location.id}>{location.name}</option> 
            ))}
            </select>

            <button onClick={handleUpdateAssignment} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2 mt-4">
              Update
            </button>
            <button onClick={() => setEditAssignment(null)} className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mt-4">
              Cancel
            </button>
          </div>
        </div>
      )}


    </div>
  );
};

export default AssignmentManagement;